import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import './DialogModal.css';

import { faCheckCircle, faExclamationTriangle, faSpinner, faTimesCircle } from '@fortawesome/fontawesome-free-solid';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import parseHtml from 'html-react-parser';

export default function DialogModal (props)  {
 const [show, setShow] = useState(false);

  return (
    <>

      {/* <Modal
        size="sm"
        show={props.modalShow}
        onHide={() => setShow(props.setModalShow(false))}
        aria-labelledby="example-modal-sizes-title-sm"
>
        <Modal.Header className='modal-header-warning' closeButton>
          <Modal.Title className='modal-dialog-centered' id="example-modal-sizes-title-sm">
          <FontAwesomeIcon icon={faExclamationTriangle} className='fa-1x mb-2 modal-icon' /> 
          {props.errorMessage}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center modal-body'>      
        
        <div>
         Please search again.</div> </Modal.Body>
         
      </Modal> */}

      <Modal show={props.modalShow} backdrop='static' onHide={props.handleModalClose} size={props.modalSize||"sm"}
      >
        <ModalHeader className='bg-card-head' closeButton>
         <ModalTitle className='text-light'>
            {props.modalTitle}
         </ModalTitle>
        </ModalHeader>
        <ModalBody className='p-2'>
          {props.messageType === "loading" &&
              <div id='loadingDiv' className='text-center'>
                  <FontAwesomeIcon icon={faSpinner} className='fa-spin fa-2x mb-1' />
                  <div>
                      Please wait . . .
                  </div>
              </div>
          }
          {props.messageType === "success" &&
              <div id='successDiv' className='text-center'>
                  <FontAwesomeIcon icon={faCheckCircle} className='text-success fa-2x mb-1' />
                  <div>
                        {props.isMessageHtml ? parseHtml(props.modalMsg) : props.modalMsg}
                  </div>
              </div>
          }
          {props.messageType === "error" &&
              <div id='errorDiv' className='text-center'>
                  <FontAwesomeIcon icon={faTimesCircle} className='text-danger fa-2x mb-1' />
                  <div>
                      {props.isMessageHtml ? parseHtml(props.modalMsg) : props.modalMsg}
                  </div>
              </div>
          }
          {props.messageType === "warning" &&
              <div id='warningDiv' className='text-center'>
                  <FontAwesomeIcon icon={faExclamationTriangle} className='text-warning fa-2x mb-1' />
                  <div>
                      {props.isMessageHtml ? parseHtml(props.modalMsg) : props.modalMsg}
                  </div>
              </div>
          }
        </ModalBody>
        {props.messageType !== "loading" &&
            <ModalFooter>
                <Button variant="secondary" onClick={props.handleModalClose}>
                  OK
                </Button>
            </ModalFooter>
        }
      </Modal>
      
    </>
  );
}